import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { chatOpenSelector } from 'shared/selectors/newbuildingConsultant';
import { selectChat } from 'shared/selectors/selectChat';
import { newbuildingChatOpenToggle } from 'shared/serp/state/newbuildingConsultant';
import { TThunkDispatch } from 'shared/types/redux';

export function useWebimChatAutoClosing() {
  const isWebimChatOpened = useSelector(chatOpenSelector);
  const { isOpened: isCianChatOpened } = useSelector(selectChat);

  const dispatch = useDispatch<TThunkDispatch>();

  useLayoutEffect(() => {
    if (isWebimChatOpened && isCianChatOpened) {
      dispatch(newbuildingChatOpenToggle(false));
    }
  }, [dispatch, isWebimChatOpened, isCianChatOpened]);
}
